import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.answerHistory.loading;
export const selectErrorMessage = (state: RootState) =>
  state.answerHistory.error;
export const answerHistoryListDataResponse = (state: RootState) =>
  state.answerHistory.answerHistoryListResponse;
